@use "../../../../../../../styles/Constants.scss" as Constants;
@use "../../../../../../../styles//Colors.scss" as Colors;

.container {
	padding: Constants.$val-spacing-m;
	background-color: Colors.$col-white;
}

.row {
	display: flex;
	justify-content: flex-start;

	& > div {
		width: calc(100% / 4);
	}

	& + & {
		margin-top: Constants.$val-spacing-m;
	}
}